// extracted by mini-css-extract-plugin
export default {"buttonCaption":"book_button_buttonCaption__ru9h6"};